import { render, staticRenderFns } from "./CreateFormKj.vue?vue&type=template&id=64078cae&scoped=true"
import script from "./CreateFormKj.vue?vue&type=script&lang=js"
export * from "./CreateFormKj.vue?vue&type=script&lang=js"
import style0 from "./CreateFormKj.vue?vue&type=style&index=0&id=64078cae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64078cae",
  null
  
)

export default component.exports